import { render, staticRenderFns } from "./DishesSorting.vue?vue&type=template&id=d8abe042&"
import script from "./DishesSorting.vue?vue&type=script&lang=js&"
export * from "./DishesSorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DishesSorting.vue"
export default component.exports